<template>
  <div class="org-dashboard">
    <!-- 顶部统计卡片 -->
    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #667eea, #764ba2)">
            <i class="el-icon-ticket"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ statistics.promoQuota || 0 }}</div>
            <div class="stat-label">剩余推广额度</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #11998e, #38ef7d)">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ statistics.totalUsers || 0 }}</div>
            <div class="stat-label">推广用户数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #f093fb, #f5576c)">
            <i class="el-icon-s-order"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ statistics.usedQuota || 0 }}</div>
            <div class="stat-label">已使用额度</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #fa709a, #fee140)">
            <i class="el-icon-money"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">¥{{ statistics.availableCommission || '0.00' }}</div>
            <div class="stat-label">可提现佣金</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 推广码区域 -->
    <el-card class="promo-card">
      <div slot="header" class="card-header">
        <span>我的推广码</span>
        <el-button type="primary" size="small" @click="generateNewCode" :loading="generating">
          生成新推广码
        </el-button>
      </div>
      <div class="promo-content">
        <div class="promo-code-display">
          <span class="promo-code">{{ orgInfo.promoCode || '暂无推广码' }}</span>
          <el-button type="text" icon="el-icon-document-copy" @click="copyPromoCode" v-if="orgInfo.promoCode">
            复制
          </el-button>
        </div>
        <div class="promo-tips">
          <p><i class="el-icon-info"></i> 用户注册时填写此推广码，将自动与您的机构绑定</p>
          <p><i class="el-icon-warning"></i> 每次用户使用推广码注册，将消耗1个推广额度</p>
        </div>
      </div>
    </el-card>

    <!-- 功能入口 -->
    <el-row :gutter="20" class="feature-cards">
      <el-col :span="8">
        <el-card class="feature-card" @click.native="$router.push('/org/users')">
          <i class="el-icon-user feature-icon"></i>
          <div class="feature-title">推广用户管理</div>
          <div class="feature-desc">查看通过推广码注册的用户</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="feature-card" @click.native="$router.push('/org/orders')">
          <i class="el-icon-s-order feature-icon"></i>
          <div class="feature-title">用户购买记录</div>
          <div class="feature-desc">查看用户的课程购买情况</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="feature-card" @click.native="$router.push('/org/settings')">
          <i class="el-icon-setting feature-icon"></i>
          <div class="feature-title">机构设置</div>
          <div class="feature-desc">管理机构信息和收款账户</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="feature-cards">
      <el-col :span="8">
        <el-card class="feature-card" @click.native="$router.push('/org/courses')">
          <i class="el-icon-notebook-2 feature-icon"></i>
          <div class="feature-title">课程管理</div>
          <div class="feature-desc">查看已创建课程并管理创建功能</div>
        </el-card>
      </el-col>

	  <el-col :span="8">
	    <el-card class="feature-card" @click.native="$router.push('/org/competition-archive')">
	      <i class="el-icon-document-checked feature-icon"></i>
	      <div class="feature-title">资料查验</div>
	      <div class="feature-desc">查看并审核绑定用户提交的竞赛资料</div>
	    </el-card>
	  </el-col>

	  <el-col :span="8">
	    <el-card class="feature-card" @click.native="$router.push('/org/teachers')">
	      <i class="el-icon-user feature-icon"></i>
	      <div class="feature-title">教师管理</div>
	      <div class="feature-desc">绑定教师并查看其创建的课程</div>
	    </el-card>
	  </el-col>
    </el-row>
  </div>
</template>

<script>
import { getOrgInfo, getOrgStatistics, generatePromoCode } from '@/api/organization'

export default {
  name: 'OrgDashboard',
  data() {
    return {
      orgInfo: {},
      statistics: {},
      generating: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const [infoRes, statsRes] = await Promise.all([
          getOrgInfo(),
          getOrgStatistics()
        ])
        if (infoRes.code === 1) {
          this.orgInfo = infoRes.data || {}
        }
        if (statsRes.code === 1) {
          this.statistics = statsRes.data || {}
        }
      } catch (e) {
        console.error('加载数据失败:', e)
      }
    },
    async generateNewCode() {
      try {
        await this.$confirm('生成新推广码后，旧推广码将失效，确定继续？', '提示', {
          type: 'warning'
        })
        this.generating = true
        const res = await generatePromoCode()
        if (res.code === 1) {
          // Vue2: 给对象新增字段需要使用 $set 才能触发视图更新
          this.$set(this.orgInfo, 'promoCode', res.data)
          this.$message.success('推广码生成成功')
        } else {
          this.$message.error(res.msg || '生成失败')
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('生成失败')
        }
      } finally {
        this.generating = false
      }
    },
    copyPromoCode() {
      if (!this.orgInfo.promoCode) return
      navigator.clipboard.writeText(this.orgInfo.promoCode).then(() => {
        this.$message.success('推广码已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败，请手动复制')
      })
    }
  }
}
</script>

<style scoped>
.org-dashboard {
  padding: 20px;
}

.stat-cards {
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 20px;
}

.stat-card .el-card__body {
  display: flex;
  align-items: center;
  width: 100%;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.stat-icon i {
  font-size: 28px;
  color: white;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
}

.promo-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.promo-content {
  text-align: center;
  padding: 20px;
}

.promo-code-display {
  margin-bottom: 20px;
}

.promo-code {
  font-size: 36px;
  font-weight: bold;
  color: #667eea;
  letter-spacing: 4px;
  margin-right: 10px;
}

.promo-tips {
  text-align: left;
  background: #f5f7fa;
  padding: 15px;
  border-radius: 8px;
}

.promo-tips p {
  margin: 8px 0;
  color: #666;
  font-size: 14px;
}

.promo-tips i {
  margin-right: 8px;
}

.feature-cards {
  margin-top: 20px;
}

.feature-card {
  text-align: center;
  padding: 30px 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 48px;
  color: #667eea;
  margin-bottom: 15px;
}

.feature-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 14px;
  color: #999;
}
</style>
